import React from 'react';
import { Col, Row, Spin } from 'antd';
import { selectCurrentProfile } from '../../../store/slices/userSlice';
import BalanceInfoCard from '../../../components/billings/BalanceInfoCard';
import { useAppSelector } from '../../../hooks/useStore';

const BillingBalances = ({ isOwner }: { isOwner: boolean }) => {
    const account = useAppSelector(selectCurrentProfile)?.account;

    return (
        <Spin spinning={!account}>
            <Row className="universal-bottom-spacing" gutter={[{ xs: 0, md: 16 }, 16]}>
                <Col xs={24} sm={16} md={12} lg={8}>
                    <BalanceInfoCard balanceType="payable" balance={Math.max(parseFloat(account?.payable_balance || '0'), 0)} />
                </Col>
                <Col xs={24} sm={16} md={12} lg={8}>
                    <BalanceInfoCard balanceType="accounting" balance={parseFloat(account?.accounting_balance || '0')} />
                </Col>
                {isOwner && (
                    <Col xs={24} sm={16} md={12} lg={8}>
                        <BalanceInfoCard balanceType="deposit" balance={Math.max(parseFloat(account?.deposit_balance || '0'), 0)} />
                    </Col>
                )}
            </Row>
        </Spin>
    );
};

export default BillingBalances;
